export default {
      id: "icon-shuffle-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-shuffle",
      toString: function () {
        return this.url;
      }
    }